import { Text } from "grommet";
import React from "react";
import { StyleSheet } from "../../../../../../../typings/StyleSheet";
import StandardColors from "../../../../../../../util/StandardColors";
import StandardFonts from "../../../../../../../util/StandardFonts";

function TitleText({ title, parentInfo }: { title: string, parentInfo: string }) {
  const styles: StyleSheet = {
    title: {
      // color: parentInfo == "complaint" ? "#4B628A" : "#41454B",
      color: "#4B628A",
      fontStyle: "normal",
      // marginTop: parentInfo == "complaint" ? 0 : 4,
      marginTop: 0,
      fontSize: parentInfo == "complaint" ? 12 : 14,
      lineHeight: "14px",
      fontWeight: parentInfo == "complaint" ? "600" : "400",
      fontFamily: "Inter",
      marginLeft: parentInfo == "complaint" ? 4 : 0,
      justifyContent: 'flex-end'
    },
  };
  return <Text style={styles.title}>{title}</Text>;
}


export default TitleText;
